import { objectUtils } from '@festina-life/core'

import type { SelectableItem } from './useSelectableItems'

export const filterItemsByText = <T>(
  items: SelectableItem<T>[],
  query: string,
) => {
  const trimmedQuery = query.trim()

  if (trimmedQuery === '') {
    return items
  }

  const lowercasedQuery = trimmedQuery.toLocaleLowerCase()

  return items.filter((item) =>
    item.textValue.toLocaleLowerCase().includes(lowercasedQuery),
  )
}

export const findOrCreateValue = <T>({
  userInput,
  items,
  valueFromString,
}: {
  userInput: string
  items: SelectableItem<T>[]
  valueFromString: (value: string) => T
}) => {
  const trimmedText = userInput.trim()

  if (trimmedText === '') {
    return undefined
  }

  const matchingItem = items.find((item) => item.textValue === trimmedText)

  return matchingItem
    ? {
        text: matchingItem.textValue,
        value: matchingItem.value,
      }
    : {
        text: trimmedText,
        value: valueFromString(trimmedText),
      }
}

// Defined once so that the defaults keep a stable identity across renders and
// do not invalidate the memoized option lists.
export const defaultRenderFn = <T>(entry: T) => `${entry}`

export const defaultKeyFn = <T>(entry: T) =>
  objectUtils.objectToSortedString(entry)
